<template>
  <div class="service-book-dashboard px-0">
    <h4 v-if="!isEmbedded" class="atlhr-dashboard-title mt-10 px-0 mb-4">
      Service Book<span
        ><a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> /
        Service Book</span
      >
    </h4>
    <div class="card card-custom gutter-b">
      <div class="card-header border-0 pt-6 pb-2 d-flex justify-content-between align-items-center bg-white">
        <h3 class="card-title align-items-start flex-column mb-0">
          <span class="card-label font-weight-bolder text-dark">Service Records</span>
          <span class="text-muted mt-1 font-weight-bold font-size-sm">Detailed employee service history 32dewr34</span>
        </h3>
        <div class="card-toolbar">
          <b-dropdown
            variant="primary"
            toggle-class="border rounded bg-light py-1 px-2"
            class="ml-2"
            right
            :disabled="downloadingAll"
          >
            <template #button-content>
              <i class="far fa-file-archive px-1" aria-hidden="true" style="font-size:16px;"></i>
              {{ downloadingAll ? 'Downloading...' : 'Download All' }}
            </template>
            <b-dropdown-item @click="handleDownloadAll('both')">Mixed (Bangla &amp; English)</b-dropdown-item>
            <b-dropdown-item @click="handleDownloadAll('bn')">Bangla Only</b-dropdown-item>
            <b-dropdown-item @click="handleDownloadAll('en')">English Only</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      
      <div class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper mx-3">
        <div class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
          <ul class="nav nav-pills leave-attendance-dashboard-tab">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'identification' }"
                @click="activeTab = 'identification'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Worker Identification</span>
                <span class="nav-subtext bn-text">শ্রমিকের পরিচয়ানুমূলক তথ্য</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'employment' }"
                @click="activeTab = 'employment'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Employer & Employment</span>
                <span class="nav-subtext bn-text">মালিক ও চাকরির তথ্য</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'service-wages' }"
                @click="activeTab = 'service-wages'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Service, Wages & Allowance</span>
                <span class="nav-subtext bn-text">মজুরি ও ভাতা রেকর্ড</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'leave' }"
                @click="activeTab = 'leave'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Leave Record</span>
                <span class="nav-subtext bn-text">ছুটির রেকর্ড</span>
              </a>
            </li>
            <li class="nav-item" v-if="!hideBehavioral">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'behavioral' }"
                @click="activeTab = 'behavioral'"
                href="javascript:void(0);"
              >
                <span class="nav-text font-weight-bolder">Behavioral Record</span>
                <span class="nav-subtext bn-text">আচরণিক রেকর্ড</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div v-if="activeTab === 'identification'">
            <!-- Updated by Jarir 2026-04-26 — uses separate components for Admin/Employee to strictly enforce upload/prop rules -->
            <service-book-emp-worker-identification-document
              v-if="isEmployeePanel"
              ref="workerIdentification"
              :is-embedded="isEmbedded"
            ></service-book-emp-worker-identification-document>
            <service-book-worker-identification-document
              v-else
              ref="workerIdentification"
              :is-embedded="isEmbedded"
            ></service-book-worker-identification-document>
          </div>
          <div v-else-if="activeTab === 'employment'">
            <!-- Updated by Jarir 2026-04-26 — uses separate components for Admin/Employee to strictly enforce upload/prop rules -->
            <service-book-emp-employer-and-employment-details
              v-if="isEmployeePanel"
              ref="employmentDetails"
              :is-embedded="isEmbedded"
            ></service-book-emp-employer-and-employment-details>
            <service-book-employer-and-employment-details
              v-else
              ref="employmentDetails"
              :is-embedded="isEmbedded"
            ></service-book-employer-and-employment-details>
          </div>
          <div v-else-if="activeTab === 'service-wages'">
            <service-book-service-wages-and-allowance-record
              ref="serviceWages"
            ></service-book-service-wages-and-allowance-record>
          </div>
          <div v-else-if="activeTab === 'leave'">
            <service-book-service-leave-record
              ref="leaveRecord"
            ></service-book-service-leave-record>
          </div>
          <!-- Updated by Jarir 2026-04-26 — gate content panel with hideBehavioral -->
          <div v-if="!hideBehavioral && activeTab === 'behavioral'">
            <service-book-service-behavioral-record
              ref="behavioralRecord"
            ></service-book-service-behavioral-record>
          </div>
        </div>
      </div>
    </div>

    <!-- Updated by Jarir 2026-04-20 — restyled to match Tax Card Download PDF / Email button look, kept centered -->
    <div class="d-flex justify-content-center mt-4 mb-5">
      <!-- Email Dropdown -->
      <b-dropdown
        variant="primary"
        toggle-class="border rounded bg-light py-1 px-2"
        class="ml-2"
        right
        :disabled="cooldowns[activeTab] && cooldowns[activeTab].email > 0"
      >
        <template #button-content>
          <i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i>
          {{
            cooldowns[activeTab] && cooldowns[activeTab].email > 0
              ? "Email (" + formatTime(cooldowns[activeTab].email) + ")"
              : "Email"
          }}
        </template>
        <b-dropdown-item @click="handleEmail('both')"
          >Bangla & English</b-dropdown-item
        >
        <b-dropdown-item @click="handleEmail('bn')"
          >Bangla Only</b-dropdown-item
        >
        <b-dropdown-item @click="handleEmail('en')"
          >English Only</b-dropdown-item
        >
      </b-dropdown>

      <!-- Download Dropdown -->
      <b-dropdown
        variant="primary"
        toggle-class="border rounded bg-light py-1 px-2"
        class="ml-2"
        right
        :disabled="cooldowns[activeTab] && cooldowns[activeTab].download > 0"
      >
        <template #button-content>
          <i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;"></i>
          {{
            cooldowns[activeTab] && cooldowns[activeTab].download > 0
              ? "Download PDF (" + formatTime(cooldowns[activeTab].download) + ")"
              : "Download PDF"
          }}
        </template>
        <b-dropdown-item @click="handleDownload('both')"
          >Bangla & English</b-dropdown-item
        >
        <b-dropdown-item @click="handleDownload('bn')"
          >Bangla Only</b-dropdown-item
        >
        <b-dropdown-item @click="handleDownload('en')"
          >English Only</b-dropdown-item
        >
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isEmbedded: {
      type: Boolean,
      default: false,
    },
    hideBehavioral: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      apiPrefix: "/admin-service-book",
      employee_id: null,
      activeTab: "identification",
      downloadingAll: false,
      cooldowns: {
        identification: { download: 0, email: 0 },
        employment: { download: 0, email: 0 },
        "service-wages": { download: 0, email: 0 },
        leave: { download: 0, email: 0 },
        behavioral: { download: 0, email: 0 },
      },
      masterTimer: null,
    };
  },
  created() {
    // Updated by Jarir 2026-04-26 — Auto-detect context from URL or parent api-prefix attr
    if (window.location.href.indexOf("/front/") !== -1) {
      this.apiPrefix = "/front/service-book";
    } else if ((this.$attrs || {})['api-prefix'] === '/front/service-book') {
      // api-prefix is not a declared prop so Vue puts it in $attrs — use it to force employee context
      this.apiPrefix = "/front/service-book";
    }
  },
  computed: {
    isEmployeePanel() {
      // Updated by Jarir 2026-04-26 — Cannot use isEmbedded as it's true in both Admin and ESS portals.
      // Must rely strictly on URL and explicit prefix.
      if (window.location.href.indexOf('/front/') !== -1) return true;
      if (this.apiPrefix === "/front/service-book") return true;
      
      return false;
    },
    storageKey() {
      return `service_book_cooldowns_${this.employee_id}`;
    },
  },
  mounted() {
    // Updated by Jarir 2026-03-02 — timers commented out for testing
    // this.loadCooldowns();
    // this.masterTimer = setInterval(() => {
    //   Object.keys(this.cooldowns).forEach((tab) => {
    //     if (this.cooldowns[tab].download > 0) this.cooldowns[tab].download--;
    //     if (this.cooldowns[tab].email > 0) this.cooldowns[tab].email--;
    //   });
    // }, 1000);
  },
  methods: {
    loadCooldowns() {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        try {
          const expirations = JSON.parse(stored);
          const now = Date.now();
          Object.keys(expirations).forEach((tab) => {
            if (this.cooldowns[tab]) {
              const dExpiry = expirations[tab].download || 0;
              const eExpiry = expirations[tab].email || 0;

              this.cooldowns[tab].download = Math.max(
                0,
                Math.ceil((dExpiry - now) / 1000),
              );
              this.cooldowns[tab].email = Math.max(
                0,
                Math.ceil((eExpiry - now) / 1000),
              );
            }
          });
        } catch (e) {
          localStorage.removeItem(this.storageKey);
        }
      }
    },
    handleDownload(lang = "both") {
      // Updated by Jarir 2026-03-02 — cooldown guard commented out for testing
      // if (this.cooldowns[this.activeTab].download > 0) return;

      if (this.activeTab === "identification") {
        if (this.$refs.workerIdentification) {
          this.$refs.workerIdentification.downloadPdf(lang);
          // this.startCooldown("download");
        } else {
          this.$bvToast.toast("Worker Identification component not ready", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } else if (this.activeTab === "employment") {
        // Updated by Jarir 2026-04-26 — backend streams PDF directly; use blob responseType
        axios
          .post(
            this.$api_url + this.apiPrefix + "/download-employment-details-pdf",
            { lang: lang },
            { responseType: "blob" },
          )
          .then((response) => {
            this.global_download_file_content(response);
          })
          .catch((error) => {
            console.error("Error downloading PDF:", error);
            this.$bvToast.toast("Error downloading PDF", {
              title: "Error", variant: "danger", solid: true, autoHideDelay: 5000,
            });
          });
        // this.startCooldown("download");
      } else if (this.activeTab === "service-wages") {
        if (this.$refs.serviceWages) {
          this.$refs.serviceWages.downloadPdf(lang);
          // this.startCooldown("download");
        } else {
          this.$bvToast.toast("Service record component not ready", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } else if (this.activeTab === "leave") {
        if (this.$refs.leaveRecord) {
          this.$refs.leaveRecord.downloadPdf(lang);
          // this.startCooldown("download");
        } else {
          this.$bvToast.toast("Leave record component not ready", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } else if (this.activeTab === "behavioral") {
        if (this.$refs.behavioralRecord) {
          this.$refs.behavioralRecord.downloadPdf(lang);
          // this.startCooldown("download");
        } else {
          this.$bvToast.toast("Behavioral record component not ready", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } else {
        this.$bvToast.toast("Download not available for this tab yet.", {
          title: "Info",
          variant: "info",
          solid: true,
        });
      }
    },
    // Updated by Jarir 2026-04-26 — backend streams ZIP directly; use blob responseType, no ghostme needed
    handleDownloadAll(lang) {
      if (this.downloadingAll) return;
      this.downloadingAll = true;
      var self = this;
      axios
        .post(
          this.$api_url + this.apiPrefix + "/download-all-pdf",
          { lang: lang },
          { responseType: "blob" }
        )
        .then(function (response) {
          self.global_download_file_content(response);
        })
        .catch(function (error) {
          console.error("Error downloading all PDFs:", error);
          self.$bvToast.toast("Error downloading all PDFs", {
            title: "Error", variant: "danger", solid: true, autoHideDelay: 5000,
          });
        })
        .finally(function () {
          self.downloadingAll = false;
        });
    },
    handleEmail(lang = "both") {
      // Updated by Jarir 2026-03-02 — cooldown guard commented out for testing
      // if (this.cooldowns[this.activeTab].email > 0) return;

      let endpoint = "";
      if (this.activeTab === "identification") {
        endpoint = this.apiPrefix + "/email-worker-identification-pdf";
      } else if (this.activeTab === "employment") {
        endpoint = this.apiPrefix + "/email-employment-details-pdf";
      } else if (this.activeTab === "service-wages") {
        endpoint = this.apiPrefix + "/email-wages-records-pdf";
      } else if (this.activeTab === "leave") {
        endpoint = this.apiPrefix + "/email-leave-records-pdf";
      } else if (this.activeTab === "behavioral") {
        endpoint = this.apiPrefix + "/email-behavioral-records-pdf";
      }

      if (!endpoint) return;

      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to email this record to the employee?",
          {
            title: "Send PDF via Email",
            okTitle: "Yes, Send",
            cancelTitle: "No",
            okVariant: "primary",
            cancelVariant: "outline-secondary",
            centered: true,
          },
        )
        .then((confirmed) => {
          if (!confirmed) return;

          this.$bvToast.toast("Sending record via email...", {
            title: "Email PDF",
            variant: "info",
            solid: true,
            noAutoHide: true,
          });

          // Updated by Jarir 2026-04-23 — employee_id removed; backend reads from session only
          axios
            .post(this.$api_url + endpoint, {})
            .then((response) => {
              this.$bvToast.hide();
              if (response.data.success) {
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  variant: "success",
                  solid: true,
                  autoHideDelay: 5000,
                });
                // this.startCooldown("email");
              } else {
                this.$bvToast.toast(
                  response.data.message || "Failed to send email",
                  {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 10000,
                  },
                );
              }
            })
            .catch((error) => {
              this.$bvToast.hide();
              this.$bvToast.toast(
                "System error occurred while sending email.",
                {
                  title: "Error",
                  variant: "danger",
                  solid: true,
                  autoHideDelay: 10000,
                },
              );
            });
        });
    },
    startCooldown(type) {
      const duration = 180; // 180 seconds
      this.cooldowns[this.activeTab][type] = duration;

      // Persist to localStorage
      const now = Date.now();
      let stored = localStorage.getItem(this.storageKey);
      let expirations = stored
        ? JSON.parse(stored)
        : {
            identification: { download: 0, email: 0 },
            employment: { download: 0, email: 0 },
            "service-wages": { download: 0, email: 0 },
            leave: { download: 0, email: 0 },
            behavioral: { download: 0, email: 0 },
          };

      expirations[this.activeTab][type] = now + duration * 1000;
      localStorage.setItem(this.storageKey, JSON.stringify(expirations));
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    },
  },
  beforeDestroy() {
    if (this.masterTimer) clearInterval(this.masterTimer);
  },
};
</script>

<style scoped>
.service-book-dashboard {
  background-color: #f4f7f6;
  padding: 0;
}
.service-book-dashboard {
  background-color: #f4f7f6;
  padding: 0;
}
.leave-attendance-dashboard-tab .nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1.5rem 0.5rem 2rem 0.5rem !important; /* Increased padding to fill container */
  min-height: 120px; /* Increased to ensure it touches the bottom border */
  overflow: visible !important;
  border-radius: 8px 8px 0 0 !important; /* Rounded top, flat bottom */
  transition: all 0.2s ease-in-out;
}
.leave-attendance-dashboard-tab .nav-link:hover {
  background-color: #f8f9fa;
}
.leave-attendance-dashboard-tab .nav-link.active {
  background-color: rgba(54, 153, 255, 0.15) !important; /* Solid light blue for the whole tab */
  color: #3699ff !important;
  box-shadow: 0 4px 10px rgba(54, 153, 255, 0.08);
}
/* Disable global pseudo-element that creates the half-blue/half-white look */
.leave-attendance-dashboard-tab .nav-link.active::after {
  display: none !important;
  content: none !important;
}
.leave-attendance-dashboard-tab {
  overflow: visible !important;
  padding: 0 !important;
  margin: 0 !important;
  border-bottom: none !important;
}
.nav-text {
  font-size: 0.95rem;
  line-height: 1.2;
}
.nav-subtext {
  font-size: 0.8rem; 
  font-weight: 500;
  opacity: 0.85;
  line-height: 1.4;
  margin-top: 6px;
  padding-bottom: 4px;
}
.bn-text {
  font-family: "notosansbengali", sans-serif;
}
.leave-attendance-dashboard.employee-tab .custom-tab-nav {
  height: auto !important;
  position: relative !important;
  top: 0 !important;
  max-width: 100% !important;
  padding: 0 !important; /* Total removal of padding */
  margin-bottom: 0 !important;
  background-color: #fff !important;
}
.leave-attendance-dashboard-tab .nav-item {
  width: 19% !important;
  margin: 0 2px 0 0 !important; /* Minimized margins */
  padding: 0 !important;
}
</style>
